import { render, staticRenderFns } from "./OrganizationPhotos.vue?vue&type=template&id=8a85354a&"
import script from "./OrganizationPhotos.vue?vue&type=script&lang=js&"
export * from "./OrganizationPhotos.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports